import { EventEmitter, Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { environment } from "src/environments/environment";
import { ApplyDbTemplateSchemaDiffResult, CreateDbTemplateField, DbTemplateFilter, DbTemplateGroup, DbTemplateInfo, DbTemplateSchemaDecision, DbTemplateSchemaDiff, TableList, TemplateUsedIn } from './db-template.model';

@Injectable({
  providedIn: 'root'
})
export class DbTemplateService {
  
  constructor(
    private http: HttpService,
  ) { }


  //db templates
  async createDbTemplate(dbNameInput: string, dbSchemaInput: string, dbTypeInput: string) : Promise<string>{
   return await this.http.post(`${environment.adminConfig.apiUri}/dbtemplate/create`, {name: dbNameInput, schema: dbSchemaInput, type: dbTypeInput});
  }

  async copyDbTemplate(templateId: string) : Promise<string>{
    return await this.http.post<string, null>(`${environment.adminConfig.apiUri}/dbtemplate/copydbtemplate/${templateId}`, null);
  }

  async getDbTables(): Promise<TableList[]> {
    return await this.http.get<TableList[]>(`${environment.adminConfig.apiUri}/dbtemplate/list`);
  }

  async getDbTemplateInfo(tableId: string) :Promise<DbTemplateInfo>
  {
    return await this.http.get<DbTemplateInfo>(`${environment.adminConfig.apiUri}/dbtemplate/${tableId}`);
  }

  async updateDbTemplate(DbTemplateInfo: DbTemplateInfo): Promise<DbTemplateInfo>{
    return await this.http.post<DbTemplateInfo, DbTemplateInfo>(`${environment.adminConfig.apiUri}/dbtemplate`, DbTemplateInfo);
  }

  async getDbTemplateSchemaDiff(tableId: string): Promise<DbTemplateSchemaDiff> {
    return await this.http.get<DbTemplateSchemaDiff>(`${environment.adminConfig.apiUri}/dbtemplate/schemadiff/${tableId}`);
  }

  async applyDbTemplateSchemaDiff(tableId: string, decisions: DbTemplateSchemaDecision[]): Promise<ApplyDbTemplateSchemaDiffResult> {
    return await this.http.post<ApplyDbTemplateSchemaDiffResult, { decisions: DbTemplateSchemaDecision[] }>(`${environment.adminConfig.apiUri}/dbtemplate/schemadiff/${tableId}/apply`, { decisions });
  }

  async createDbTemplateField(tableId: string, field: CreateDbTemplateField): Promise<string> {
    return await this.http.post<string, CreateDbTemplateField>(`${environment.adminConfig.apiUri}/dbtemplate/${tableId}/field`, field);
  }

  async deleteDbTemplateField(tableId: string, itemId: string): Promise<boolean> {
    return await this.http.delete<boolean>(`${environment.adminConfig.apiUri}/dbtemplate/${tableId}/field/${itemId}`);
  }

  async getdbTemplateUsedIn(tableId: string): Promise<TemplateUsedIn[]> {
    return await this.http.get<TemplateUsedIn[]>(`${environment.adminConfig.apiUri}/dbtemplate/usedin/${tableId}`);
  }

  getValueTypes(vartype: string): string[] {
    if (vartype === 'int') {
      return ['Db: Identity', 'Api: KundeId', 'Api: RegnskabId' ];
    } else if (vartype === 'datetime' ||vartype === 'datetime2' ) {
      return ['Api: Oprettet (dato)', 'Api: Rettet (dato)', 'Api: Slettet (dato)'];
    } else if (vartype === 'bit') {  
      return ['Api: Slettet (bit)'];
    } else if (vartype === 'uniqueidentifier') {
      return ['Api: Oprettet (guid)', 'Api: Rettet (guid)', 'Api: Slettet (guid)'];
    }
    return [];  
  }

  deleteDbTemplate(tableId: string): Promise<void> {
    return this.http.delete(`${environment.adminConfig.apiUri}/dbtemplate/${tableId}`);
  }
  
  async getDbTemplateFiltre(tableId: string): Promise<DbTemplateFilter[]> {
    return await this.http.get<DbTemplateFilter[]>(`${environment.adminConfig.apiUri}/dbtemplate/filter/${tableId}`);
  }

  async saveDbTemplateFilter(tableId: string, filter: DbTemplateFilter[]): Promise<boolean> {
    return await this.http.post<boolean, DbTemplateFilter[]>(`${environment.adminConfig.apiUri}/dbtemplate/filter/save/${tableId}`, filter);
  }

  
}
